// "just now", "5 min ago", "3 h ago", "2 d ago", "4 mo ago". A value that is missing or is
// not a date gives null, so callers can leave the label out.
export function timeAgo(value, now = Date.now()) {
  if (!value) return null
  const then = new Date(value).getTime()
  if (Number.isNaN(then)) return null

  const minutes = Math.round((now - then) / 60000)
  if (minutes < 1) return 'just now' // also covers a clock that is a little ahead
  if (minutes < 60) return `${minutes} min ago`

  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} h ago`

  const days = Math.round(hours / 24)
  if (days < 30) return `${days} d ago`

  return `${Math.round(days / 30)} mo ago`
}

// "Sep 26, 2026", or null for a missing or invalid date.
export function formatDate(value) {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null

  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

// How long ago a job was posted, in the words LinkedIn uses ("2 hours ago", "1 week ago"), from the date the job was
// posted. LinkedIn only ever gave the job's age at the moment it was fetched, so the extension saved the date it
// works out to; counting from that date to now keeps the age right however long ago the job was saved. A missing or
// invalid date gives null, so callers can fall back to the text LinkedIn gave.
export function postedAgo(value, now = Date.now()) {
  if (!value) return null
  const then = new Date(value).getTime()
  if (Number.isNaN(then)) return null

  const plural = (count, unit) => `${count} ${unit}${count === 1 ? '' : 's'} ago`
  const minutes = Math.floor((now - then) / 60000)
  if (minutes < 1) return 'just now' // also covers a clock that is a little ahead
  if (minutes < 60) return plural(minutes, 'minute')

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return plural(hours, 'hour')

  const days = Math.floor(hours / 24)
  if (days < 7) return plural(days, 'day')
  if (days < 30) return plural(Math.floor(days / 7), 'week')
  if (days < 365) return plural(Math.floor(days / 30), 'month')
  return plural(Math.floor(days / 365), 'year')
}
